import { fetchWithAuth, BASE_BACKEND_URL } from '../../auth'
import { useState, useEffect, useContext, useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { Box, Typography } from '@mui/material'
import { Table } from 'react-bootstrap'
import { UserInfoContext } from '../context/UserInfoProvider'
import dayjs from '../../utils/dayjsConfig'
import LoadingSpinner from '../../components/LoadingSpinner'
const UserAuditTab = () => {
  const { userInfoData } = useContext(UserInfoContext)
  const [isFetching, setIsFetching] = useState(false)
  const [userRefundAuditData, setUserRefundAuditData] = useState([])

  useEffect(() => {
    const abortController = new AbortController()

    const handleBeforeUnload = () => abortController.abort('Fetch aborted by user')
    window.addEventListener('beforeunload', handleBeforeUnload)

    fetchUserRefundAuditsFromServer(abortController.signal)

    return () => {
      abortController.abort()
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  useEffect(() => {
    async function fetchAll() {
      await fetchUserRefundAuditsFromServer()
    }
    fetchAll()
  }, [])

  const fetchUserRefundAuditsFromServer = useCallback(async () => {
    //Fetch de data de tabla
    setIsFetching(true)
    const response = await fetchWithAuth(
      `${BASE_BACKEND_URL}/user_refund_limits?user_uid=${userInfoData.uid}&user_limits_audits=true`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )

    if (!response) {
      return console.error(response)
    } else {
      setUserRefundAuditData(response['result'])
    }
    setIsFetching(false)
  }, [])

  return (
    <Box sx={{ pt: 0 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          borderBottom: '1px solid #E5E7EB',
          pb: 2,
          mb: 2
        }}
      >
        <Typography sx={{ fontSize: 18 }}>Historial del máximo de devoluciones:</Typography>
      </Box>
      {!isFetching && (
        <>
          <div className="mt-25">
            <b>Ajustes registrados</b>
          </div>
          <div className="mt-20">
            <Table hover responsive>
              <thead className="table-header-gray-mui">
                <tr>
                  <th className="vertical-align-middle" style={{ padding: '10px 25px' }}>
                    <span className="th-header-text">FECHA Y HORA</span>
                  </th>
                  <th
                    className="vertical-align-middle"
                    title="Es el nombre del usuario que realizó el ajuste del máximo de devoluciones."
                  >
                    <span className="th-header-text">NOMBRE DE USUARIO</span>
                    <FontAwesomeIcon icon={faQuestionCircle} className="ml-2" />
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">TIPO DE CAMBIO</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">REGISTRO ANTERIOR</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">REGISTRO NUEVO</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {userRefundAuditData?.map((month, indx) => (
                  <tr key={indx}>
                    <td className="td-text-limited td-text-limited-space">
                      {dayjs(month.created_at).local().format('DD/MM/YYYY, h:mm A')}
                    </td>
                    <td className="td-text-limited">{month.supervisor_name}</td>
                    <td className="td-text-limited">{`MÁXIMO DE DEVOLUCIONES`}</td>
                    <td className="td-text-limited">
                      {month.action == 'create'
                        ? '$0.00'
                        : `$${Number(month.audited_changes.current_amount[0]).toFixed(2)}`}
                    </td>
                    <td className="td-text-limited">
                      {month.action == 'create'
                        ? `$${Number(month.audited_changes.current_amount).toFixed(2)}`
                        : `$${Number(month.audited_changes.current_amount[1]).toFixed(2)}`}
                    </td>
                  </tr>
                ))}
                {userRefundAuditData?.length === 0 && (
                  <tr>
                    <td colSpan="5" className="td-text-no-border">
                      Aún no hay ajustes registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>{' '}
        </>
      )}
      {isFetching && (
        <div className="updating-screen">
          <div className="loading-card">
            <LoadingSpinner text="Cargando" size={25} color="#747474" />
          </div>
        </div>
      )}
    </Box>
  )
}

export default UserAuditTab
